module.exports = ".yeti-aside-body {\n  text-align: center;\n  margin-top: 2rem; }\n\n.yeti-table-header {\n  width: 100% !important; }\n\n.yeti-table-body {\n  text-align: left; }\n\n.rollbackButton {\n  text-align: center;\n  width: 10rem; }\n\n.model-not-available {\n  color: #d9534f; }\n\n#rollbackRevisionMessage {\n  font-size: 1.2rem;\n  margin-bottom: 1.25rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/revert-revision-aside/revert-revision-aside.component.scss
// module id = 641
// module chunks = 0